

import React, { useEffect, useState } from 'react';
import {
  Card,
  CardHeader,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  IconButton, 
  Box,
  useTheme,
  Fade,
  Grow,
  Grid,
  useMediaQuery, BottomNavigation,
  BottomNavigationAction,   Paper
} from '@mui/material';
import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Link } from 'react-router-dom';
import { BASE_URL } from "./../../Api/ApiUrls";
import FormsBottomNavbar from './../Post Module/FormsBottomNavbar';
import logotop from './Images/landnest-logo.jpg';
 

const ConstructionPackages = () => {
  const [packages, setPackages] = useState([]);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
   const [value, setValue] = useState('construction');
    const location = useLocation();

  const [expanded, setExpanded] = React.useState({
    package2000: null,
    package2300: null,
    package2500: null
  });

  const handleChange = (panel, packageType) => (event, newExpanded) => {
    setExpanded(prev => ({
      ...prev,
      [packageType]: newExpanded ? panel : null
    }));
  };

  const formatContent = (content) => {
    return content.split('\n').map((line, index) => {
      if (line.includes(':')) {
        const parts = line.split(':');
        return (
          <React.Fragment key={index}>
            <strong>{parts[0]}:</strong>{parts[1]}
            <br />
          </React.Fragment>
        );
      }
      return (
        <React.Fragment key={index}>
          {line}
          <br />
        </React.Fragment>
      );
    });
  };

  const transformApiDataToPackageContent = (apiData) => {
  // Helper function to format currency values
  const formatCurrency = (value) => value ? `₹${value}` : 'Not specified';
  
  // Determine which package we're transforming based on package_id
  switch(apiData.package_id) {
    case 2: // package2500 (Basic Package)
      return {
        design: "• <strong>2D Floor Plans</strong> \n• <strong>3D Elevations</strong>",
        materials: `• <strong>Steel:</strong> Fe500/550 Grade TMT (A-One Gold, Prime Gold, or Equivalent)
• <strong>Cement:</strong> 53 & 43 Grade (Bharathi, Dalmia, Maha, or Equivalent)
• <strong>Aggregates:</strong> 20mm & 40mm
• <strong>Sand:</strong> M-Sand for blockwork, P-Sand for plastering
• <strong>Blocks:</strong> Solid Blocks (6″ {36 per pic} & 4″ {28 per pic})
• <strong>Concrete Mix:</strong> RMC or hand mix – M20 Grade
• <strong>Underground Sump:</strong> 6″ solid block with waterproof plastering
• <strong>Plinth Foundation:</strong> One course of size stone masonry
• <strong>Ceiling Height:</strong> 10 feet (floor to floor)
• <strong>Waterproofing:</strong> Dr. Fixit or Fosroc`,
        flooring: `• <strong>Living, Kitchen, Dining & Bedroom:</strong> Tiles up to ${formatCurrency(apiData.tile_general)}/sq.ft
• <strong>Staircase:</strong> Granite up to ${formatCurrency(apiData.tile_stair)}/sq.ft
• <strong>Balconies & Sitouts:</strong> Anti-skid tiles up to ${formatCurrency(apiData.tile_balcony)}/sq.ft
• <strong>Bathrooms/Toilets:</strong> Wall & floor tiles up to ${formatCurrency(apiData.title_bathroom)}/sq.ft
• <strong>Parking Area:</strong> Flooring up to ${formatCurrency(apiData.tile_parking)}/sq.ft
• <strong>Kitchen Countertop:</strong> Granite up to ${formatCurrency(apiData.tile_kitchen_countertop)}/sq.ft
• <strong>Kitchen Backsplash (Dadoing, 4ft height):</strong> Tiles up to ${formatCurrency(apiData.tile_kitchen_backsplash)}/sq.ft
• <strong>Bathroom Wall Tiling:</strong> Up to 7 feet height
• <strong>Terrace Finishing:</strong> Screed concrete`,
        windows: `• <strong>Standard Windows:</strong> 2-track UPVC with 5mm glass & MS grill (${formatCurrency(apiData.window_standered)}/sq.ft)
• <strong>Maximum Window Openings:</strong> 2.5-track Aluminum with 4mm glass & MS grill
• <strong>Maximum Window Coverage:</strong> 10% of total wall space`,
        doors: `• <strong>Main Door:</strong> Teakwood frame (5″x3″) with teak shutter & fittings (${formatCurrency(apiData.doors_main)} per door)
• <strong>Pooja Room Door:</strong> Frame (5″x3″) with readymade shutter & fittings (${formatCurrency(apiData.doors_pooja)} per door)
• <strong>Internal Doors:</strong> WPC or neem wood frame (4″x3″) with membrane shutter & fittings (${formatCurrency(apiData.doors_internal)} per door)
• <strong>Bathroom Doors:</strong> PVC/WPC doors`,
        painting: `• <strong>Interior Walls & Ceilings:</strong> 2 coats putty + 1 coat primer + 2 coats of Asian Tractor Emulsion
• <strong>Exterior Walls:</strong> 1 coat primer + 2 coats of ACE Emulsion
• <strong>Windows & MS Grills:</strong> 2 coats of enamel paint
• <strong>Paint Brands:</strong> Asian, Berger, Dulux (as per owner preference)`,
        fabrication: `• <strong>MS Staircase Railing:</strong> ${formatCurrency(apiData.fabrication_stair_rail)}/sq.ft (3′ height)
• <strong>MS Standard Gate:</strong> ${formatCurrency(apiData.fabrication_gate)}/sq.ft (5′ height)`,
        plumbing: `• <strong>Pipes:</strong> CPVC (Ashirwad, Supreme, Astral)
• <strong>Overhead Tank:</strong> PVC (Ganga or Kaveri) with MS support (6ft height)
• <strong>Solar & Geyser Provision:</strong> Diverter and mixer-ready
• <strong>Sanitary Installations:</strong>
  o <strong>Overhead tank:</strong> ${formatCurrency(apiData.sanitary_overheadtank)}
  o <strong>Commode:</strong> ${formatCurrency(apiData.sanitary_commode)}
  o <strong>Wall mixer:</strong> ${formatCurrency(apiData.sanitary_wallmixer)}`,
        extra: `• <strong>Compound Wall Construction</strong>
• <strong>BBMP/BDA Approvals & Liaison Fees</strong>
• <strong>Building Plinth Level Above 18″ from Road</strong>
• <strong>External Ramps & Landscaping, road cutting works</strong>
• <strong>Extra Depth for Sump Tank, Rain water sump</strong>
• <strong>Interior Works (Wardrobes, False Ceiling, etc.)</strong>
• <strong>External Elevation Cladding</strong>
• <strong>Security Fabrication Works</strong>
• <strong>Any Civil Works Outside the Main House</strong>
• <strong>Additional Height for Compound Wall</strong>
• <strong>Electrical Fixtures (Lights, Fans, Bulbs, etc.)</strong>
• <strong>Additional Charges for Soil Bearing Capacity < 180 SBC</strong>`,
        sanctions: `Assistance with approvals from government agencies, including:
• <strong>Construction Plan Sanction</strong>
• <strong>Temporary Electricity Connection</strong>
• <strong>Permanent Electrical Connection</strong>
• <strong>Water Connection</strong>
• <strong>Sewage Connection</strong>`,
        elevation: `<strong>Elevation Budget:</strong> 0.25% of the Project's Super Built-Up Cost`,
        audit: `• <strong>Soil Testing:</strong> Additional charges
• <strong>Site Supervision:</strong> Civil Engineer & Project Manager assigned
• <strong>Architect Visits:</strong> Additional charges`
      };
      
    case 4: // package2300 (Premium Construction)
      return {
        design: "• <strong>2D Floor Plans</strong> \n• <strong>3D Elevation</strong> \n• <strong>Structural Drawing</strong> \n• <strong>Plumbing & Electrical Layout</strong> \n• <strong>Working Drawings for Execution & Schedule of Openings</strong>",
        materials: `• <strong>Steel:</strong> Fe500/550 Grade TMT – Indus, Prime Gold, JSW, or Tata Equivalent
• <strong>Cement:</strong> 53 & 43 Grades (Birla, ACC, Ultratech, or Equivalent)
• <strong>Aggregates:</strong> 20MM & 40MM
• <strong>Sand:</strong> M-Sand for Blockwork & P-Sand for Plastering
• <strong>Blocks:</strong> Solid Blocks : 6″ {55 per pic} & 4″ {45 per pic}
• <strong>Concrete Mix:</strong> RMC – M20 Grade`,
        foundation: `• <strong>Underground Sump</strong> 6″ Solid Block, Waterproof Plastered
• <strong>Plinth Foundation</strong> Two-Course Size Stone Masonry Under Plinth
• <strong>Ceiling Height:</strong> 10 Feet (Floor to Floor)
• <strong>Waterproofing:</strong> Dr. Fixit or Fosroc`,
        flooring: `• <strong>Living, Kitchen, Dining & Bedroom:</strong> ${formatCurrency(apiData.tile_general)}/sq.ft
• <strong>Staircase:</strong> Granite up to ${formatCurrency(apiData.tile_stair)}/sq.ft
• <strong>Balconies & Sitouts:</strong> Anti-skid tiles up to ${formatCurrency(apiData.tile_balcony)}/sq.ft
• <strong>Bathroom/Toilet Wall & Flooring:</strong> ${formatCurrency(apiData.title_bathroom)}/sq.ft
• <strong>Parking Floor:</strong> ${formatCurrency(apiData.tile_parking)}/sq.ft
• <strong>Kitchen Countertop:</strong> ${formatCurrency(apiData.tile_kitchen_countertop)}/sq.ft
• <strong>Kitchen Dadoing (2 feet tiles):</strong> ${formatCurrency(apiData.tile_kitchen_backsplash)}/sq.ft
• <strong>Bathroom Dadoing (10 feet height):</strong> Included
• <strong>Terrace:</strong> Screed Concreting`,
        windows: `• <strong>Windows:</strong> 3-Track UPVC with 5mm Glass & MS Grill (Budget ${formatCurrency(apiData.window_standered)}/sq.ft)
• <strong>Maximum Opening Percentage:</strong> 15%`,
        doors: `• <strong>Main Door:</strong> Teak Wood Frame (6″X6″) + Teak Door Shutter (${formatCurrency(apiData.doors_main)} per door)
• <strong>Pooja Door:</strong> 5″X3″ Readymade Door (${formatCurrency(apiData.doors_pooja)} per door)
• <strong>Internal Doors:</strong> WPC/Sal Frame (4″X3″) + Membrane Door Shutter (${formatCurrency(apiData.doors_internal)} per door)
• <strong>Bathroom Doors:</strong> WPC`,
        painting: `• <strong>Interior Walls & Ceiling:</strong> 2 Coats Putty + 1 Coat Primer + 2 Coats of Asian Royale
• <strong>Exterior Walls:</strong> 1 Coat Primer + 2 Coats of Apex ultima
• <strong>Windows MS Grills:</strong> 2 Coats of Enamel Paint
• <strong>Brands Considered:</strong> Asian, Berger, Dulux (Owner's Choice)`,
        fabrication: `• <strong>MS Staircase Railing:</strong> ${formatCurrency(apiData.fabrication_stair_rail)}/sq.ft (3'6” height)
• <strong>MS Standard Gate:</strong> ${formatCurrency(apiData.fabrication_gate)}/sq.ft (6' height)`,
        plumbing: `• <strong>Pipes:</strong> Ashirwad / Supreme / Astral CPVC
• <strong>Water Tank:</strong> PVC Overhead Tank (Ganga/Kaveri) with MS Structure (6' height)
• <strong>Solar & Geyser Provision:</strong> Provided for Diverters/Mixtures Only
• <strong>Sewage Chambers:</strong> PVC Cover Inside Plot Area (Overhead Tank: ${formatCurrency(apiData.sanitary_overheadtank)}, Commode: ${formatCurrency(apiData.sanitary_commode)}, Wall Mixer: ${formatCurrency(apiData.sanitary_wallmixer)})`,
        extra: `• <strong>Liaison Work:</strong> BBMP/BDA or other approving bodies
• <strong>Extra Civil Work:</strong>
  o Floor Level more than 18″ above Road Level
  o Outside Ramping & Extra Sump Depth, Rain water sump
  o Interior Works (Wardrobe, False Ceiling, etc.)
  o External Cladding for Elevation
  o Landscaping & Security Fabrication Work
  o Any Civil Work outside House Area Road cutting
  o Additional Height for Compound
• <strong>Electrical Fittings:</strong> Light Tubes, Bulbs, Fans, etc., not included
• <strong>Soil Bearing Capacity (SBC):</strong> Extra charges if SBC < 180`,
        sanctions: `Assistance for:
• <strong>Construction Plan Sanction:</strong> Included
• <strong>Temporary Electricity Connection:</strong> Included
• <strong>Permanent Electrical Connection:</strong> Included
• <strong>Water Connection:</strong> Included
• <strong>Sewage Connection:</strong> Included`,
        additional: `• <strong>Elevation Budget:</strong> 1.25% of Project Super built Cost
• <strong>Soil Testing:</strong> Extra charges
• <strong>Site Supervision:</strong> Civil Engineer & PM assigned
• <strong>Architect Visits:</strong> Extra charges`
      };
      
    case 6: // package2000 (Premium Package Details)
      return {
        design: "• <strong>2D Floor Plans:</strong> \n• <strong>3D Elevation:</strong> \n• <strong>Plumbing & Electrical Layout:</strong> \n• <strong>Working Drawings for Execution, Schedule of Openings:</strong>",
        materials: `• <strong>Steel:</strong> Fe500/550 Grade TMT (Meenakshi, Prime Gold, Turbo, Indus, or Equivalent)
• <strong>Cement:</strong> 53 & 43 Grade (Zuari, ACC, Ramco, Birla super or Equivalent)
• <strong>Aggregates:</strong> 20mm & 40mm
• <strong>Sand:</strong> M-Sand for Blockwork, P-Sand for Plastering
• <strong>Blocks:</strong> 6″ {42 per pic} & 4″ {32 per pic}
• <strong>Concrete Mix:</strong> RMC or handmix– M25 Grade
• <strong>Underground Sump:</strong> 6″ solid block with waterproof plastering
• <strong>Plinth Foundation:</strong> Three-course size stone masonry
• <strong>Ceiling Height:</strong> 10 feet (floor to floor)
• <strong>Waterproofing:</strong> Dr. Fixit or Fosroc`,
        flooring: `• <strong>Living, Kitchen, Dining & Bedroom:</strong> Tiles up to ${formatCurrency(apiData.tile_general)}/sq.ft
• <strong>Staircase:</strong> Granite up to ${formatCurrency(apiData.tile_stair)}/sq.ft
• <strong>Balconies & Sitout Areas:</strong> Anti-skid tiles up to ${formatCurrency(apiData.tile_balcony)}/sq.ft
• <strong>Bathroom Wall & Flooring:</strong> Tiles up to ${formatCurrency(apiData.title_bathroom)}/sq.ft
• <strong>Parking Area:</strong> Flooring up to ${formatCurrency(apiData.tile_parking)}/sq.ft
• <strong>Kitchen Countertop:</strong> Granite up to ${formatCurrency(apiData.tile_kitchen_countertop)}/sq.ft
• <strong>Kitchen Backsplash (Dadoing, 4ft height):</strong> Tiles up to ${formatCurrency(apiData.tile_kitchen_backsplash)}/sq.ft
• <strong>Bathroom Wall Tiling:</strong> Up to 8 feet height
• <strong>Terrace Finishing:</strong> Screed concrete`,
        windows: `• <strong>Standard Windows:</strong> 2.5-3 track UPVC with 5mm glass & MS grill (${formatCurrency(apiData.window_standered)}/sq.ft)
• <strong>Maximum Window Openings:</strong> 3-track UPVC with 5mm glass & MS grill (${formatCurrency(apiData.window_ms_grill)}/sq.ft) or Sal wood frames with shutters
• <strong>Maximum Window Coverage:</strong> 10% of total wall space`,
        doors: `• <strong>Main Door:</strong> Teakwood frame (6″x4″) with teak shutter & fittings (${formatCurrency(apiData.doors_main)} per door)
• <strong>Pooja Room Door:</strong> Frame (5″x3″) with readymade shutter & fittings (${formatCurrency(apiData.doors_pooja)} per door)
• <strong>Internal Doors:</strong> WPC or Sal wood frame (4″x3″) with membrane shutter & fittings (${formatCurrency(apiData.doors_internal)} per door)
• <strong>Bathroom Doors:</strong> WPC doors`,
        painting: `• <strong>Interior Walls & Ceilings:</strong> 2 coats putty + 1 coat primer + 2 coats of Asian Tractor Emulsion
• <strong>Exterior Walls:</strong> 1 coat primer + 2 coats of Apex Emulsion
• <strong>Windows & MS Grills:</strong> 2 coats of enamel paint
• <strong>Paint Brands:</strong> Asian, Berger, Dulux (as per owner preference)`,
        fabrication: `• <strong>MS Staircase Railing:</strong> ${formatCurrency(apiData.fabrication_stair_rail)}/sq.ft (3′ height)
• <strong>MS Standard Gate:</strong> ${formatCurrency(apiData.fabrication_gate)}/sq.ft (5′ height)`,
        plumbing: `• <strong>Pipes:</strong> CPVC (Ashirwad, Supreme, Astral)
• <strong>Overhead Tank:</strong> PVC (Ganga or Kaveri) with MS support (6ft height)
• <strong>Solar & Geyser Provision:</strong> Diverter and mixer-ready
• <strong>Sanitary Installations:</strong>
  o <strong>Overhead tank:</strong> ${formatCurrency(apiData.sanitary_overheadtank)}
  o <strong>Commode:</strong> ${formatCurrency(apiData.sanitary_commode)}
  o <strong>Wall mixer set:</strong> ${formatCurrency(apiData.sanitary_wallmixer)}`,
        extra: `• <strong>BBMP/BDA Approvals & Liaison Fees:</strong>  
• <strong>Building Plinth Level Above 18″ from Road:</strong>  
• <strong>External Ramps & Landscaping:</strong>  
• <strong>Extra Depth for Sump Tank,Rain water sump, gas lines:</strong>  
• <strong>Interior Works (Wardrobes, False Ceiling, etc.):</strong>  
• <strong>External Elevation Cladding:</strong>  
• <strong>Security Fabrication Works:</strong>  
• <strong>Any Civil Works Outside the Main House,Road cutting:</strong>  
• <strong>Additional Height for Compound Wall:</strong>  
• <strong>Electrical Fixtures (Lights, Fans, Bulbs, etc.):</strong>  
• <strong>Additional Charges for Soil Bearing Capacity < 180 SBC:</strong>`,
        sanctions: `We assist with obtaining permissions, approvals, and sanction fees for:
• <strong>Construction Plan Sanction:</strong> Assistance provided
• <strong>Temporary Electricity Connection:</strong> Assistance provided
• <strong>Permanent Electrical Connection:</strong> Assistance provided
• <strong>Water Connection:</strong> Assistance provided
• <strong>Sewage Connection:</strong> Assistance provided`,
        elevation: `<strong>Elevation Budget:</strong> 0.5% of the Project's Super Built-Up Cost`,
        audit: `• <strong>Soil Testing:</strong> Additional charges
• <strong>Site Supervision:</strong> Civil Engineer & Project Manager assigned
• <strong>Architect Visits:</strong> Additional charges`
      };
      
    default:
      return null;
  }
};

// Example usage:
// Fetch API data for each package and transform it
const fetchAndTransformPackages = async () => {
  try {
    // Fetch data for each package
    const [pkg2500Res, pkg2300Res, pkg2000Res] = await Promise.all([
      fetch(`${BASE_URL}/packages/2/`),
      fetch(`${BASE_URL}/packages/4/`),
       fetch(`${BASE_URL}/packages/6/`),
    ]);
    
    const [pkg2500Data, pkg2300Data, pkg2000Data] = await Promise.all([
      pkg2500Res.json(),
      pkg2300Res.json(),
      pkg2000Res.json()
    ]);
    
    // Transform the API data to match your sectionContent structure
    const sectionContent = {
      package2500: transformApiDataToPackageContent(pkg2500Data),
      package2300: transformApiDataToPackageContent(pkg2300Data),
      package2000: transformApiDataToPackageContent(pkg2000Data)
    };

 
  const packages = [
    {
      id: 'package2500',
        title: pkg2500Data.category || 'Basic Package Details',
        price: `Rs ${pkg2500Data.package_cost}/sqft`,
      color: '', // White text for better contrast
  gradient: 'linear-gradient(135deg,rgb(101, 81, 77),rgb(124, 119, 119))', // Coffee to black gradient
      sections: [
        { id: 'pkg2500One', title: 'Design & Drawings', content: sectionContent.package2500.design },
        { id: 'pkg2500Two', title: 'Construction Materials', content: sectionContent.package2500.materials },
        { id: 'pkg2500Three', title: 'Flooring & Wall Tiling', content: sectionContent.package2500.flooring },
        { id: 'pkg2500Four', title: 'Windows', content: sectionContent.package2500.windows },
        { id: 'pkg2500Five', title: 'Doors', content: sectionContent.package2500.doors },
        { id: 'pkg2500Six', title: 'Painting & Finishing', content: sectionContent.package2500.painting },
        { id: 'pkg2500Seven', title: 'Fabrication Works', content: sectionContent.package2500.fabrication },
        { id: 'pkg2500Eight', title: 'Plumbing & Sanitary', content: sectionContent.package2500.plumbing },
        { id: 'pkg2500Nine', title: 'Extra Charges', content: sectionContent.package2500.extra },
        { id: 'pkg2500Ten', title: 'Government Sanctions & Electrical Assistance', content: sectionContent.package2500.sanctions },
        { id: 'pkg2500Eleven', title: 'Elevation Budget', content: sectionContent.package2500.elevation },
        { id: 'pkg2500Twelve', title: 'Site Audit & Reporting', content: sectionContent.package2500.audit }
      ]
    },
    {
      id: 'package2000',
        title: pkg2000Data.category || 'Construction Package Details',
        price: `Rs ${pkg2000Data.package_cost}/sqft`,
      color: '', // White text for better contrast
      gradient: 'linear-gradient(135deg,rgb(101, 81, 77),rgb(124, 119, 119))',      sections: [
        { id: 'pkg2000One', title: 'Design & Drawings', content: sectionContent.package2000.design },
        { id: 'pkg2000Two', title: 'Core Construction Materials', content: sectionContent.package2000.materials },
        { id: 'pkg2000Three', title: 'Flooring & Wall Tiling', content: sectionContent.package2000.flooring },
        { id: 'pkg2000Four', title: 'Windows', content: sectionContent.package2000.windows },
        { id: 'pkg2000Five', title: 'Doors', content: sectionContent.package2000.doors },
        { id: 'pkg2000Six', title: 'Painting & Finishing', content: sectionContent.package2000.painting },
        { id: 'pkg2000Seven', title: 'Fabrication Works', content: sectionContent.package2000.fabrication },
        { id: 'pkg2000Eight', title: 'Plumbing & Sanitary', content: sectionContent.package2000.plumbing },
        { id: 'pkg2000Nine', title: 'Extra Charges', content: sectionContent.package2000.extra },
        { id: 'pkg2000Ten', title: 'Government Sanctions & Electrical Assistance', content: sectionContent.package2000.sanctions },
        { id: 'pkg2000Eleven', title: 'Elevation Budget', content: sectionContent.package2000.elevation },
        { id: 'pkg2000Twelve', title: 'Site Audit & Reporting', content: sectionContent.package2000.audit }
      ]
    }, 
    {
      id: 'package2300',
        title: pkg2300Data.category || 'Construction Package Details',
        price: `Rs ${pkg2300Data.package_cost}/sqft`,
      // title: 'Construction Package Details',
      // price: 'Rs 2300/sqft',
      color: '', // White text for better contrast
      gradient: 'linear-gradient(135deg,rgb(101, 81, 77),rgb(124, 119, 119))',      sections: [
        { id: 'pkg2300One', title: 'Design & Drawings', content: sectionContent.package2300.design },
        { id: 'pkg2300Two', title: 'Materials & Construction', content: sectionContent.package2300.materials },
        { id: 'pkg2300Three', title: 'Foundation & Waterproofing', content: sectionContent.package2300.foundation },
        { id: 'pkg2300Four', title: 'Flooring & Finishing', content: sectionContent.package2300.flooring },
        { id: 'pkg2300Five', title: 'Windows', content: sectionContent.package2300.windows },
        { id: 'pkg2300Six', title: 'Doors', content: sectionContent.package2300.doors },
        { id: 'pkg2300Seven', title: 'Painting & Finishing', content: sectionContent.package2300.painting },
        { id: 'pkg2300Eight', title: 'Railings & Gates', content: sectionContent.package2300.fabrication },
        { id: 'pkg2300Nine', title: 'Plumbing & Sanitation', content: sectionContent.package2300.plumbing },
        { id: 'pkg2300Ten', title: 'Exclusions & Additional Charges', content: sectionContent.package2300.extra },
        { id: 'pkg2300Eleven', title: 'Government Approvals & Utilities', content: sectionContent.package2300.sanctions },
        { id: 'pkg2300Twelve', title: 'Additional Charges', content: sectionContent.package2300.additional }
      ]
    },
   
  ];
   setPackages(packages);
  return { sectionContent, packages };
    } catch (error) {
    console.error('Error fetching package data:', error);
    return null;
  }
};

fetchAndTransformPackages().then(data => {
  if (data) {
    // Use data.sectionContent and data.packages in your application
    console.log('Transformed data:', data);
  }
});


  const handleChangebottom = (event, newValue) => {
    setValue(newValue);
    // Navigate to the corresponding route
    switch (newValue) {
      case 'home':
        navigate('/dashboard');
        break;
      case 'construction':
        navigate('/constructions');
        break;
      case 'post':
        navigate('/post');
        break;
      case 'services':
        navigate('/home-service');
        break;
      case 'profile':
        navigate('/work-detail');
        break;
      default:
        navigate('/');
    }
  };

  return (

    <>
    <Fade in={true} timeout={800}>
      <Box sx={{
        minHeight: '100vh',
        background: 'linear-gradient(to bottom, #f8f9fa, #e9ecef)',
        pb: 6

      }}>
       {/* Sticky Header Section */}
       <Box sx={{
       position: 'sticky',
       top: 0,
       zIndex: 1200,
       bgcolor: 'background.paper',
       boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
     }}>
       {/* Top Navigation Bar */}
       <Box display="flex" alignItems="center" justifyContent="space-between" p={1} sx={{
         background: 'black',
         borderBottom: '1px solid rgba(0,0,0,0.08)'
       }}>
         {/* Back Arrow - Left Side */}
         <IconButton
           onClick={() => navigate(-1)}
           sx={{
             color: 'white',
             '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' }
           }}
         >
           <ArrowBackIosIcon />
         </IconButton>
         
         {/* Center Text - "landnest" */}
         <Typography variant="h6" component="div" sx={{ 
           color: 'white',
           fontWeight: 'bold',
           flexGrow: 1,
           textAlign: 'left'
         }}>
           LANDNEST
         </Typography>
         
         {/* Right Side Logo */}
         <Box sx={{ 
           width: 100,
           height: 50,
           display: 'flex',
           alignItems: 'center',
           justifyContent: 'center'
         }}>
           <img 
             src={logotop} 
             alt="Landnest Logo" 
             style={{ 
               maxWidth: '100%', 
               maxHeight: '100%',
               objectFit: 'contain'
             }}
           />
         </Box>
       </Box>
     
       {/* Construction/Interior Navigation */}
      <Box sx={{
                  padding: isMobile ? 1 : 0.5,
                  display: 'flex',
                  justifyContent: 'space-between',
                  boxShadow: '0 5px 10px rgba(0,0,0,0.1)',
                }}>
                  {/* Construction - Active */}
                  <Box
                    component={Link}
                    to="/constructions"
                    sx={{
                      flex: 1,
                      textAlign: 'center',
                      py: 2,
                      textDecoration: 'none',
                      position: 'relative',
                      background: `
                        linear-gradient(145deg, rgba(232,224,208,0.95), rgba(216,204,186,0.95)),
                        url('/construction4.png')
                      `,
                      backgroundBlendMode: 'overlay',
                      borderRight: '1px solid rgba(0,0,0,0.1)',
                      borderTopLeftRadius: '30px',
                      boxShadow: `
                        inset 0 0 15px rgba(0,0,0,0.2),
                        0 4px 10px rgba(0,0,0,0.15)
                      `,
                      transform: 'scale(1.02)',
                      transition: 'all 0.3s ease',
                      zIndex: 1,
                      '&:hover': {
                        transform: 'scale(1.05)',
                        boxShadow: `
                          inset 0 0 20px rgba(0,0,0,0.15),
                          0 5px 12px rgba(0,0,0,0.18)
                        `,
                        '&::after': {
                          width: '70%',
                          backgroundColor: '#333333',
                        }
                      },
                      '&::after': {
                        content: '""',
                        position: 'absolute',
                        bottom: 0,
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: '70%',
                        height: '3px',
                        backgroundColor: '#333333',
                        borderRadius: '3px',
                        transition: 'all 0.3s ease',
                      }
                    }}>
                    <Typography variant={isMobile ? "h6" : "h5"} component="div" sx={{
                      fontWeight: 800,
                      color: '#333333',
                      textShadow: '0 1px 3px rgba(255,255,255,0.5)',
                      fontFamily: 'Inter, Roboto, Helvetica, sans-serif',
                      transform: 'scale(1.05)',
                      transition: 'transform 0.3s ease',
                    }}>
                      Constructions
                    </Typography>
                  </Box>
                
                  {/* Interiors - Inactive */}
                  <Box
                    component={Link}
                    to="/interiors"
                    sx={{
                      flex: 1,
                      textAlign: 'center',
                      py: 2,
                      position: 'relative',
                      background: `
                        linear-gradient(145deg, rgb(22, 22, 22), rgb(15, 15, 15)),
                        url('/construction5.png')
                      `,
                      backgroundBlendMode: 'overlay',
                      textDecoration: 'none',
                      borderBottomRightRadius: '30px',
                      boxShadow: `
                        inset 0 0 15px rgba(0,0,0,0.2),
                        0 2px 5px rgba(0,0,0,0.1)
                      `,
                      transform: 'scale(0.98)',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        background: `
                          linear-gradient(145deg, rgb(35, 35, 35), rgb(25, 25, 25)),
                          url('/construction5.png')
                        `,
                        transform: 'scale(1)',
                        boxShadow: `
                          inset 0 0 20px rgba(0,0,0,0.3),
                          0 3px 8px rgba(0,0,0,0.2)
                        `,
                        '&::after': {
                          width: '70%',
                          backgroundColor: 'rgba(255,255,255,0.9)',
                        }
                      },
                      '&::after': {
                        content: '""',
                        position: 'absolute',
                        bottom: 0,
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: '0%',
                        height: '3px',
                        backgroundColor: 'transparent',
                        borderRadius: '3px',
                        transition: 'all 0.3s ease',
                      }
                    }}
                  >
                    <Typography variant={isMobile ? "h6" : "h5"} component="div" sx={{
                      fontWeight: 700,
                      color: 'rgba(255,255,255,0.9)',
                      letterSpacing: '1px',
                      textShadow: '0 1px 5px rgba(0,0,0,0.7)',
                      fontFamily: 'Inter, Roboto, Helvetica, sans-serif',
                      transform: 'scale(1)',
                      transition: 'transform 0.3s ease',
                    }}>
                      Interiors
                    </Typography>
                  </Box>
                </Box>
     </Box>

        <Box sx={{
          px: { xs: 2, sm: 4, md: 6 },
          pt: 2,
          maxWidth: '1200px',
          margin: '0 auto',
          backgroundColor: '#e7dbc9',
          pb: 0.5

        }}>
          {packages.map((pkg, index) => (
            <Grow in={true} timeout={index * 200 + 400} key={pkg.id}>
              <Card
                sx={{
                  borderRadius: '16px',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                  marginBottom: '40px',
                  overflow: 'hidden',
                  transition: 'transform 0.4s, box-shadow 0.4s',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: '0 15px 35px rgba(0,0,0,0.15)'
                  },
                  border: 'none'
                }}
              >
                <CardHeader
                  title={
                    <Typography variant="h5" sx={{
                      fontWeight: 700,
                      color: 'white',
                      fontSize: '20px',
                      letterSpacing: '0.5px',
                    }}>
                      {pkg.title}
                    </Typography>
                  }
                  subheader={
                    <Typography variant="h4" sx={{
                      fontWeight: 700,
                      color: 'white',
                      mt: 0.5,
                      background: 'rgba(255,255,255,0.2)',
                      display: 'inline-block',
                      px: 3,
                      py: 1,
                      borderRadius: '20px',
                      backdropFilter: 'blur(5px)',
                      fontSize: '20px'
                    }}>
                      {pkg.price}
                    </Typography>
                  }
                  sx={{
                    background: pkg.gradient,
                    padding: '30px 20px',
                    textAlign: 'center',
                    position: 'relative',
                    '&:after': {
                      content: '""',
                      position: 'absolute',
                      bottom: 0,
                      left: '50%',
                      transform: 'translateX(-50%)',
                      width: '100px',
                      height: '4px',
                      backgroundColor: 'rgba(255,255,255,0.5)',
                      borderRadius: '2px'
                    }
                  }}
                />

                <Box sx={{ background: '#fff' }}>
                  {pkg.sections.map((section) => (
                    <Accordion
                      key={section.id}
                      expanded={expanded[pkg.id] == section.id}
                      onChange={handleChange(section.id, pkg.id)}
                      sx={{
                        '&:before': { display: 'none' },
                        boxShadow: 'none',
                        borderBottom: '1px solid rgba(0,0,0,0.05)',
                        backgroundColor: expanded[pkg.id] == section.id ? 'rgba(74, 0, 224, 0.03)' : 'transparent',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          backgroundColor: 'rgba(74, 0, 224, 0.03)'
                        }
                      }}
                    >
                      <AccordionSummary
                        expandIcon={
                          expanded[pkg.id] == section.id ?
                            <RemoveIcon sx={{ color: pkg.color }} /> :
                            <AddIcon sx={{ color: '#666' }} />
                        }
                        aria-controls={`${section.id}-content`}
                        id={`${section.id}-header`}
                        sx={{
                          padding: '0 25px',
                          minHeight: '68px !important',
                          '& .MuiAccordionSummary-content': {
                            margin: '12px 0',
                            alignItems: 'center'
                          }
                        }}
                      >
                        <Typography sx={{
                          fontWeight: 600,
                          color: expanded[pkg.id] == section.id ? pkg.color : '#444',
                          fontSize: '18px',
                          letterSpacing: '0.2px'
                        }}>
                          {section.title}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails sx={{
                        padding: '0 25px 25px',
                        backgroundColor: '#fff',
                        borderLeft: `3px solid ${pkg.color}`,
                        marginLeft: '25px',
                        marginBottom: '15px',
                        borderRadius: '0 8px 8px 0',
                        transition: 'all 0.3s ease'
                      }}>
                        <Typography variant="body1" sx={{
                          color: '#555',
                          textAlign: 'left',
                          lineHeight: '1.8',
                          fontSize: '0.95rem',
                          whiteSpace: 'pre-line'
                        }}>
                          <span dangerouslySetInnerHTML={{ __html: section.content }} />
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </Box>
              </Card>
            </Grow>
          ))}
        </Box>
      </Box>
    </Fade>

    {/* <Paper
            sx={{
              position: 'fixed',
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: 1000,
            }}
            elevation={3}
          >
            <BottomNavigation
              value={value}
              onChange={handleChangebottom}
              showLabels
              sx={{
                borderTop: '1px solid #e0e0e0',
                height: '60px',
                '& .MuiBottomNavigationAction-root': {
                  minWidth: 'auto',
                  padding: '6px 0',
                  color: 'black',
                },
                '& .MuiBottomNavigationAction-label': {
                  fontSize: '0.7rem',
                },
              }}
            >
              <BottomNavigationAction
                value="home"
                label="Home"
                icon={<HomeIcon sx={{ fontSize: '1.3rem' }} />}
              />
              <BottomNavigationAction
                value="construction"
                label="Construction & Interiors"
                icon={<BuildIcon sx={{ fontSize: '1.3rem' }} />}
              />
              <BottomNavigationAction
                value="post"
                label="Post"
                icon={<AddIcon sx={{ fontSize: '1.3rem' }} />}
                sx={{
                  '& .MuiSvgIcon-root': { color: '#2196f3' },
                  '& .MuiBottomNavigationAction-label': { color: '#2196f3' }
                }}
              />
              <BottomNavigationAction
                value="services"
                label="Home Services"
                icon={<CleaningServicesIcon sx={{ fontSize: '1.3rem' }} />}
              />
              <BottomNavigationAction
                value="profile"
                label="Profile"
                icon={<AccountCircleIcon sx={{ fontSize: '1.3rem' }} />}
              />
            </BottomNavigation>
                </Paper> */}
                      <FormsBottomNavbar />
                

    </>
  );
};

export default ConstructionPackages;


